import { Nullable } from 'v5/platform/typescript';

/**
 * Layer 2 — browsing scope: list API workspace filters from resolved app scope (URL).
 *
 * @see .cursor/rules/workspace-scoping-layers.mdc
 */

export type WorkspaceScoping = { workspaceId: Nullable<number> };

export type WithWorkspaceScoping<T> = T & WorkspaceScoping;

export const workspaceScopingQueryUtils = {
  ofGlobal: (): WorkspaceScoping => ({ workspaceId: null }),
  ofWorkspace: (workspaceId: number): WorkspaceScoping => ({ workspaceId })
};

export function withWorkspaceScoping<T>(
  searchQuery: T,
  scoping: WorkspaceScoping
): WithWorkspaceScoping<T> {
  return { ...searchQuery, ...scoping };
}

export function asGlobalResourceQuery<T>(
  searchQuery: T
): WithWorkspaceScoping<T> {
  return withWorkspaceScoping(
    searchQuery,
    workspaceScopingQueryUtils.ofGlobal()
  );
}
